import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Lista from './views/Lista.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/lista/',
      name: 'Lista',
      component: Lista,
    },
    {
      path: '/lista/:slug',
      name: 'Listaelem',
      component: Lista,
    },
  ],
});
